import React from 'react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import {
    BogMessageIndicator,
    BogMessageWrapper,
} from 'src/domains/layouts/webview/components/Messages/BogBanner.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';

interface BogBannerPropsType {
    message: React.ReactNode | string;
}

export const BogBanner = observer('BogBanner', ({ message }: BogBannerPropsType) => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    return (
        <BogMessageWrapper
            data-test='bog-indicator-msg'
            variant={configState.componentVariants.betslipVariant}
        >
            <BogMessageIndicator
                size='small'
                variant='primary'
                label={
                    <I18n
                        langKey='events.bog'
                        defaultText='BOG'
                    />
                }
            />

            {message}
        </BogMessageWrapper>
    );
});
